// extracted by mini-css-extract-plugin
module.exports = {"MainPage":"Content_MainPage__RgZbo"};